export default __webpack_public_path__ + "static/media/547.2779dd9a.gif";